import {AvtaleRessurs} from "../tjenester/ressurser/AvtaleRessurs";

export function landkodeForInjisering() {
    return [landkode];
}

export function landkode(): Function {
    const land = AvtaleRessurs.landkoder();
    return function (landkode: string) {
        if (!land[landkode]) return landkode;
        return land[landkode];
    };
}
